/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Open_DocumentInputs */

const cs_signing_open_document = /** @type {(inputs: Signing_Open_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít v Dokumentech`)
};

const en_signing_open_document = /** @type {(inputs: Signing_Open_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Documents`)
};

/**
* | output |
* | --- |
* | "Open in Documents" |
*
* @param {Signing_Open_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_open_document = /** @type {((inputs?: Signing_Open_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Open_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_open_document(inputs)
	return cs_signing_open_document(inputs)
});